/**
 * DashboardVersionToggle — opt-in switch between the legacy dashboard and
 * the new Penpot-matched dashboard. Only rendered for the prod-allowlisted
 * tenants (see dashboardVersion.ts).
 */

import * as React from "react";
import Switch from "rc-switch";
import type { DashboardVersion } from "./dashboardVersion";

type Props = {
  value: DashboardVersion;
  onChange: (next: DashboardVersion) => void;
};

export default function DashboardVersionToggle({ value, onChange }: Props) {
  const isNew = value === "new";
  return (
    <div className="flex items-center gap-2 flex-shrink-0 self-start">
      <span className="text-sm text-gray-600 whitespace-nowrap">Try new dashboard</span>
      <Switch
        checked={isNew}
        onChange={(checked: boolean) => onChange(checked ? "new" : "old")}
      />
    </div>
  );
}
